import Icon from '../components/Icon.vue'

Icon.register({"twitch":{"width":1792,"height":1792,"paths":[{"d":"M896 434v434h-145v-434h145zM1294 434v434h-145v-434h145zM1294 1194l253-254v-795h-1194v1049h326v217l217-217h398zM1692 0v1013l-434 434h-326l-217 217h-217v-217h-398v-1158l109-289h1483z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/twitch.js
// module id = 7r4J
// module chunks = 1